export default "__VITE_ASSET__BjD6Srth__"